// generated by bun run generate from the SwiftUI SDK and codegen/catalog.ts.
// edit the generator or catalog, then regenerate.
import type { ViewProps } from 'react-native';
import type { DirectEventHandler, Int32, Double } from 'react-native/Libraries/Types/CodegenTypes';
import codegenNativeComponent from 'react-native/Libraries/Utilities/codegenNativeComponent';
interface NativeProps extends ViewProps {
  fadeTop: Double;
  fadeBottom: Double;
  fadeLeft: Double;
  fadeRight: Double;
  curveTop: string;
  curveBottom: string;
  curveLeft: string;
  curveRight: string;
  fadeRadius: Double;
  mode: string;
  blurRadius: Double;
  frostProgression: Double;
  overlayColor: Int32;
}
const NativeComponentRegistry = require('react-native/Libraries/NativeComponent/NativeComponentRegistry');
let nativeComponentName = 'OneNativeEdgeFade';
export const __INTERNAL_VIEW_CONFIG = {
  uiViewClassName: "OneNativeEdgeFade",
  validAttributes: {
    fadeTop: true,
    fadeBottom: true,
    fadeLeft: true,
    fadeRight: true,
    curveTop: true,
    curveBottom: true,
    curveLeft: true,
    curveRight: true,
    fadeRadius: true,
    mode: true,
    blurRadius: true,
    frostProgression: true,
    overlayColor: true
  }
};
export default NativeComponentRegistry.get(nativeComponentName, () => __INTERNAL_VIEW_CONFIG);